export const objectToPlainString = (key: string): string => {
    // Capitalize the first letter of each word
    return key
        .split(/(?=[A-Z])/) // Split based on uppercase letters
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
